import { getData , getFile } from './index';
import * as FileSaver from 'file-saver';

import {
  GET_RECEPTION_LIST,
  GET_BADGE,
  // GET_RECEPTION_USER,
  ERROR_RECEPTION,
  // MESSAGE_RECEPTION
} from "./types"

export async function getReceptionListAction(dispatch , event){
  let url = "/user/" + event
  let receptionList;
  await getData( ERROR_RECEPTION, url, dispatch , true).then((response)=>{
    receptionList = response.users
  })
  
  dispatch({
    type : GET_RECEPTION_LIST,
    payload : receptionList
  })
}

export async function getBadgeFileAction(dispatch , user , event ){
  let url = "/user/badge/" + user._id
  let badge;
  await getFile( ERROR_RECEPTION, url, dispatch , true).then((response)=>{
    badge = response
    var eventName = "cocktail"
    if (event === "day1") eventName = "12-06";
    if (event === "day2") eventName = "13-06";
    var blob = new Blob([badge], {type: "data:application/pdf"});
    FileSaver.saveAs(blob, `badge-${user.profile.lastName}-${eventName}.pdf`);
  })
};

export async function getBadgeAction(dispatch , id ){
  let url = "/user/qrcode/" + id
  let badge;
  await getData( ERROR_RECEPTION, url, dispatch , true).then((response)=>{
    badge = response.code;
  });
  dispatch({
    type : GET_BADGE,
    payload : badge
  })
}